import { Divider, Grid } from '@mui/material'
import React from 'react'
import { useFormFactor } from '../../../../../../../../hooks'
import { useRetention } from '../../hooks/useRetention'
import { DETAILS, FEEDBACK, REVIEW, STEPS } from '../../pages'
import Step from './step'
import { useStyles } from './styles'

const ProgressSteps = () => {
  const { state } = useRetention()
  const { isMobile } = useFormFactor()
  const classes = useStyles()

  const isActive = page => {
    return page === state.activePage
  }

  const isComplete = page => {
    return STEPS.indexOf(page) < STEPS.indexOf(state.activePage)
  }

  return (
    <Grid container justifyContent='center' alignItems='center' data-test='retention-progress'>
      <Step label='Feedback' index={1} active={isActive(FEEDBACK)} complete={isComplete(FEEDBACK)} data-test='retention-progress-step-1' />
      {!isMobile && <Divider orientation='horizontal' className={classes.divider} />}
      <Step label='Details' index={2} active={isActive(DETAILS)} complete={isComplete(DETAILS)} data-test='retention-progress-step-2' />
      {!isMobile && <Divider orientation='horizontal' className={classes.divider} />}
      <Step label='Review' index={3} active={isActive(REVIEW)} complete={isComplete(REVIEW)} data-test='retention-progress-step-3' />
    </Grid>
  )
}

export default ProgressSteps
